function initMenuMobile() {
    const btnMobile = document.querySelector('.mw-menu-mobile__button');
    const menuMobile = document.querySelector('.mw-menu-mobile');

    if (!btnMobile || !menuMobile) return;

    // Bouton hamburger — ouvre/ferme le menu
    btnMobile.addEventListener('click', function (event) {
        event.stopPropagation(); // empêche le listener document de voir ce clic
        const isOpen = menuMobile.classList.toggle('open');
        btnMobile.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        const controlElement = document.getElementById(btnMobile.getAttribute('aria-controls'));
        if (controlElement) {
            if (isOpen) {
                btnMobile.classList.add('mw-menu-mobile__close-btn');
                controlElement.classList.add('active');
            } else {
                btnMobile.classList.remove('mw-menu-mobile__close-btn');
                controlElement.classList.remove('active');
            }
        }
    });

    // Delegation unique sur le menu : gère tous les clics (container + chevron + svg)
    menuMobile.addEventListener('click', function (event) {
        // Ne pas interférer avec le bouton hamburger
        if (event.target.closest('.mw-menu-mobile__button')) return;

        // ── Niveau 2 : sub-item dropdown ──────────────────────────────
        const lvl2Container = event.target.closest(
            '.mw-menu-mobile__sub-item--dropdown > .mw-menu-mobile__sub-item--container'
        );
        if (lvl2Container) {
            event.preventDefault();
            const subItem = lvl2Container.parentElement;
            const subSubContainer = subItem.querySelector('.mw-menu-mobile__subsub-container');
            const isOpen = subItem.classList.contains('is-open');

            subItem.classList.toggle('is-open', !isOpen);
            if (subSubContainer) subSubContainer.style.display = isOpen ? 'none' : 'block';
            return;
        }

        // ── Niveau 1 : item dropdown (primaire + secondaire) ──────────
        const lvl1Container = event.target.closest(
            '.mw-menu-mobile__item--dropdown > .mw-menu-mobile__item-container'
        );
        if (lvl1Container) {
            event.preventDefault();
            const item = lvl1Container.parentElement;
            const subContainer = item.querySelector('.mw-menu-mobile__sub-container');
            const isOpen = item.classList.contains('is-open');

            // Ferme tous les autres dropdowns du même niveau
            document.querySelectorAll('.mw-menu-mobile__item--dropdown').forEach(function (otherItem) {
                if (otherItem !== item) {
                    otherItem.classList.remove('is-open');
                    const otherSub = otherItem.querySelector('.mw-menu-mobile__sub-container');
                    if (otherSub) otherSub.style.display = 'none';
                }
            });

            item.classList.toggle('is-open', !isOpen);
            if (subContainer) subContainer.style.display = isOpen ? 'none' : 'block';
        }
    });

    // Ferme tout si on clique en dehors du menu et du bouton
    document.addEventListener('click', function (event) {
        if (event.target.closest('.mw-menu-mobile') || event.target.closest('.mw-menu-mobile__button')) return;

        document.querySelectorAll('.mw-menu-mobile__item--dropdown').forEach(function (item) {
            item.classList.remove('is-open');
            const sub = item.querySelector('.mw-menu-mobile__sub-container');
            if (sub) sub.style.display = 'none';
        });
        document.querySelectorAll('.mw-menu-mobile__sub-item--dropdown').forEach(function (subItem) {
            subItem.classList.remove('is-open');
            const subSub = subItem.querySelector('.mw-menu-mobile__subsub-container');
            if (subSub) subSub.style.display = 'none';
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuMobile);
} else {
    initMenuMobile();
}
